import Hero from "./Hero";
import Container from "./ui/Container";
import SectionHeader from "./ui/SectionHeader";
import { PrimaryButton } from "./ui/Buttons";

export default function RealEstate() {
    const properties = [
        { type: "Residential Property", desc: "Buy your dream home with easy financing." },
        { type: "Commercial Property", desc: "Invest in commercial spaces with flexible loans." },
        { type: "Land Purchase", desc: "Secure plots for personal or business use." },
        { type: "Rental Property", desc: "Invest in rental properties for steady income." },
    ];

    const features = [
        "Expert guidance on property investments",
        "Flexible property loans",
        "Trusted financial support",
        "Quick approval process",
    ];

    const partners = [
        "Partner Realty 1",
        "Partner Realty 2",
        "Partner Realty 3",
        "Partner Realty 4",
    ];

    return (
        <>
            <Hero />

            {/* Intro Section */}
            <section className="py-16 bg-gray-50">
                <Container>
                    <SectionHeader
                        title="Real Estate"
                        subtitle="Property loans & investments"
                    />
                    <p className="mt-4 text-gray-700 max-w-3xl">
                        Buy, sell, or invest in real estate with our trusted financial support and expert guidance.
                        We provide solutions tailored for residential, commercial, and rental properties.
                    </p>
                </Container>
            </section>

            {/* Property Cards */}
            <section className="py-8 bg-gray-100">
                <Container>
                    <h2 className="text-2xl font-bold mb-6">Our Property Solutions</h2>
                    <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
                        {properties.map((p, i) => (
                            <div key={i} className="p-6 bg-white shadow rounded-lg">
                                <h3 className="text-xl font-bold text-blue-600">{p.type}</h3>
                                <p className="mt-2 text-gray-600">{p.desc}</p>
                            </div>
                        ))}
                    </div>
                </Container>
            </section>

            {/* Features Section */}
            <section className="py-16 bg-white">
                <Container>
                    <h2 className="text-2xl font-bold mb-6">Why Choose Us for Real Estate?</h2>
                    <ul className="list-disc list-inside text-gray-700 space-y-2">
                        {features.map((f, i) => (
                            <li key={i}>{f}</li>
                        ))}
                    </ul>
                </Container>
            </section>

            {/* Partners Section */}
            <section className="py-16 bg-gray-50">
                <Container>
                    <h2 className="text-2xl font-bold mb-6">Our Partners</h2>
                    <ul className="grid md:grid-cols-2 gap-4 text-gray-700">
                        {partners.map((p, i) => (
                            <li key={i} className="bg-gray-50 p-4 rounded shadow">
                                {p}
                            </li>
                        ))}
                    </ul>
                </Container>
            </section>

            {/* CTA Section */}
            <section className="py-16 bg-blue-50">
                <Container className="text-center">
                    <h2 className="text-2xl font-bold mb-4">Explore Real Estate Opportunities</h2>
                    <p className="text-gray-700 mb-6">
                        Get in touch to learn more about property loans and investment options.
                    </p>
                    <PrimaryButton onClick={() => window.location.href = "/contact"}>
                        Contact Us
                    </PrimaryButton>
                </Container>
            </section>
        </>
    );
}
